import React from 'react';

import styles from '../HoverCard/styles/styles.module.scss';

import AddRemoveButton from '../../shared/AddRemoveButton/AddRemoveButton';
import CardBottomButtons from '../CardBottomButtons';
import CardImage from '../CardImage';
import CardLink from '../CardLink';
import CompletedBadge from '../../shared/badges/CompletedBadge/CompletedBadge';
import FavoriteButton from '../../shared/FavoriteButton';
import TrailCardContent from '../TrailCardContent';
import { getTrailProfilePhotoUrl, getFormattedTrailUrls, getLocalizedName } from '../../../utils/trail_helpers';
import { wrapEventHandler } from '../../../utils/handlers';

export default function TrailHoverCard({
  allowClickingCompletedBadge,
  allowItemAdd,
  bottomButtonsConfig,
  context,
  forceCityLink,
  handleCardClick,
  handleCompletedBadgeClick,
  handleFavoriteClick,
  handleItemAddClick,
  handleLocationClick,
  handleMouseEnter,
  handleMouseLeave,
  isCompleted,
  isFavorite,
  isVerified,
  itemAddLabel,
  trail,
  trailUrl
}) {
  const renderAddButton = allowItemAdd && handleItemAddClick;
  if (!trailUrl) {
    trailUrl = getFormattedTrailUrls(trail, context).localizedUrl;
  }
  return (
    <div className={styles.container} onMouseEnter={wrapEventHandler(handleMouseEnter)} onMouseLeave={wrapEventHandler(handleMouseLeave)}>
      {/* statically positioned */}
      <CardLink target="_blank" title={getLocalizedName(trail, context.languageRegionCode)} url={trailUrl} handleClick={handleCardClick} />
      <CardImage className={styles.image} url={getTrailProfilePhotoUrl(trail, 'medium')} title={trail.name} lazyload={false} />
      <div className={styles.contentContainer}>
        <TrailCardContent
          bottomButtonsConfig={bottomButtonsConfig}
          className={styles.content}
          context={context}
          forceCityLink={forceCityLink}
          handleLocationClick={handleLocationClick}
          namePaddingRight={renderAddButton ? 54 : 24}
          trail={trail}
        />
        <CardBottomButtons className={styles.bottomButtons} config={bottomButtonsConfig} />
      </div>
      {/* absolute positioned */}
      <CompletedBadge
        shortened
        className={styles.badge}
        isCompleted={isCompleted}
        isVerified={isVerified}
        handleClick={allowClickingCompletedBadge ? handleCompletedBadgeClick : null}
      />
      {renderAddButton && <AddRemoveButton addLabel={itemAddLabel} className={styles.add} handleClick={handleItemAddClick} isInCollection={false} />}
      <FavoriteButton className={styles.favorite} onWhiteBg handleFavoriteClick={handleFavoriteClick} isFavorite={isFavorite} />
    </div>
  );
}
